'use strict';

var Utils = require('../utils/utils');
var Overlay = require('../overlay/overlay');
var Megamenu = require('../megamenu/megamenu');
var MegamenuVisibility = require('../megamenu/lib/visibility');

// Constructor
var Search = function() {

  var self = this;
  var $html = $('html');
  var $document = $(document);

  self.config = {
    'modal'         :  '.search__modal',
    'inner'         :  '.search__inner',
    'show'          :  '.search__show-modal',
    'hide'          :  '.search__hide-modal',
    'input'         :  '.search__input',
    'megamenuItem'  :  '.megamenu__item',
    'mainHeader'    :  '.main-header'
  }

  var $modal = $(self.config.modal);
  var $inner = $(self.config.inner);
  var $show = $(self.config.show);
  var $hide = $(self.config.hide);
  var $input = $(self.config.input);
  var $megamenuItem = $(self.config.megamenuItem);
  var $mainHeader = $(self.config.mainHeader);

  self.clickHandler = function($button, cb) {
    $button.on('click.searchModal', function() {
      cb();
    });
  }

  self.showModal = function() {

    var delay = 0;

    if ($megamenuItem.hasClass('is-visible')) {
      delay = 250;
      self.hideMegamenu();
    }

    new Overlay().showOverlay();

    $html.addClass('search-modal-is-open');
    $modal
      .addClass('is-visible')
      .velocity('fadeIn',{
        duration: 0,
        delay: delay,
        complete: function() {
          $inner
            .velocity({
              translateY: [0, '-100%']
            },{
              easing: 'easeOutQuart'
            });
          $input.focus();
        }
      });
  }

  self.hideModal = function() {

    if ($modal.hasClass('is-visible')) {
      $html.removeClass('search-modal-is-open');
      $modal.removeClass('is-visible');
      $inner
        .velocity({
          translateY: ['-100%', 0]
        },{
          easing: 'easeOutQuart',
          complete: function() {
            $modal
              .velocity('fadeOut',{
                duration: 0
              });
          }
        });

      new Overlay().hideOverlay();
    }
  }

  self.documentClickHandler = function() {
    $document.on('click.searchModal', function(e) {
      if (!$(e.target).closest($mainHeader).length) {
        if ($modal.hasClass('is-visible') && !$modal.hasClass('velocity-animating')) {
          self.hideModal();
        }
      }
    });
  }

  self.hideMegamenu = function() {

    var megamenuConfig = new Megamenu().config;

    new MegamenuVisibility({
      item: megamenuConfig.navAlphaLevelItem,
      link: megamenuConfig.navAlphaLevelLink,
      megamenuItem: megamenuConfig.megamenuItem,
      megamenuItemGrid: megamenuConfig.megamenuItemGrid,
      mainHeader: megamenuConfig.mainHeader
    }).hideCurrentSubnavs(null, null, true, true);
  }

  self.destroy = function() {
    $document.off('click.searchModal');
    $html.removeClass('search-modal-is-open');
    $show.off('click.searchModal');
    $hide.off('click.searchModal');
    $modal
      .removeAttr('style')
      .removeClass('is-visible velocity-animating');
    $inner
      .removeAttr('style');
    new Overlay().hideOverlay();
  }

  self.init = function() {
    var largeViewports = function() {
      self.clickHandler($show, self.showModal);
      self.clickHandler($hide, self.hideModal);
      self.documentClickHandler();
    };
    var smallViewports = function() {
      self.destroy();
    };
    new Utils().matchmediaHandler('MEDIUM', largeViewports, smallViewports);
  }
};

module.exports = Search;
